import React, { useState } from 'react';
import { Drawer, Input, Checkbox, Space, Card, Image, Row, Col, Typography } from 'antd';
import {prUrl} from '../config.js'
import ShipDetails from './ShipDetails';
import { cordConvertEng } from '../../utils'
import locationIcon from '../../images/location.png'
import search from '../../images/Union.svg'
import Icon from "@ant-design/icons";

const {Title} = Typography



const ShipListDrawer = (props) => {
    const [isShipModalOpen, setIsShipModalOpen] = useState(false)
    const [ship, setShip] = useState(null)
    const [active, setActive] = useState('')

    const handleShipModalShow = () => {
        setIsShipModalOpen(!isShipModalOpen)
        setActive('')
    }

    const handleOnClick = (ship, index) => {
        handleShipModalShow()
        setShip(ship)
        setActive(index)
    }

    const location = () => (
        <Image src={locationIcon} preview={false}/>
    )

    const gotoMarker = (marker) => {
        props.globe.goTo(marker.position.latitude, marker.position.longitude, 10e4)
    }

    const GotoButton = (props) => {    
        return (
            <Icon component={location} onClick={(e) => props.gotoMarker(props.marker, e)}/>
        );
    }
  
    const searchIcon = () => (
        <Image src={search} preview={false}/>
    )

    var checkBoxList
    if (props.shipTypes){
        checkBoxList = (
            <div className="checkboxList">
                {
                    Object.keys(props.shipTypes).sort((a,b)=> a.length - b.length).map((type)=>{
                        return(
                            <Space style={{left:'20px'}}>
                            <Checkbox onChange={props.handleCheck} id={type} name={type} value={type} checked={props.shipTypes[type]} />
                            <label for={type}>{type}&nbsp;&nbsp;&nbsp;</label>
                            </Space>
                        )
                    })
                }
            </div>
        )
    }   
    
    return(
        <React.Fragment>
            <Drawer
                className='listDrawer'
                title={<span className="drawerTitle">舰船列表</span>}
                placement="left"
                closable={false}
                onClose={props.handleShipDrawerShow}
                visible={props.isShipDrawerShow}
                getContainer={false}
                width={'450'}>
                <div className="drawerSearch">
                    <Input placeholder="请输入筛选条件……" type="text" onKeyUp={props.handleFilter}/>
                    <div className="drawerSearchIcon">
                        <Icon component={searchIcon}/>
                    </div>
                </div>
                
                {checkBoxList}
                {
                    props.filteredShips.map((item, index) => 
                        <Card className={active === index ? 'drawer-list-item-active drawer-list-item' : 'drawer-list-item'} hoverable title={<Title level={5} style={{cursor:'pointer'}} onClick={(e) => handleOnClick(item.ship, index, e)}>{item.ship.shipName}</Title>} extra={<GotoButton gotoMarker={gotoMarker} marker={item.marker} globe={props.globe}/>} style={{ width: 385, border:'false' }}>
                            <Row  align='middle' justify='center'>
                                <Col span={10}>
                                    <Image src={prUrl+item.ship.thumbImage} preview={false} style={{cursor:'pointer'}} onClick={(e) => handleOnClick(item.ship, index, e)}/>
                                </Col>
                                <Col span={12} offset={1}>                
                                    <p style={{cursor:'pointer'}} onClick={(e) => handleOnClick(item.ship, index, e)}>船名：{item.ship.engName}</p>
                                    <p style={{cursor:'pointer'}} onClick={(e) => gotoMarker(item.marker, e)}>位置：{cordConvertEng(item.ship.lat, item.ship.lon)}</p>
                                    <p>时间：{item.ship.startTime}</p>
                                </Col>
                            </Row>
                        </Card>
                    )
                }
            </Drawer>
            {
                isShipModalOpen ?
                <ShipDetails isModalOpen={isShipModalOpen} ship={ship} handleModalShow={handleShipModalShow}/> : ''
            }
        </React.Fragment>
    )
};

export default ShipListDrawer;